import { Grid, Stack, TextField, Typography } from "@mui/material";
import React from "react";
import styled from "styled-components";
import request from "src/utils/request";
import InvitationModal from "src/scenes/subscription/invitation-modal";
import useApi from "src/utils/api/use-api";
import EnterprisePlanList from "src/scenes/setup-wizard/enterprise/enterprise-plan-list";
import LoadingButton from "@mui/lab/LoadingButton";
import AnnouncementIcon from "@mui/icons-material/Announcement";
import EnterpriseInvitesList from "src/scenes/setup-wizard/enterprise/enterprise-invites-list";

const Title = styled.p`
    margin: 8px;
`;

const Subtitle = styled.p`
    font-size: 12px;
    margin: 8px;
`;

const EnterpriseInviteSection = ({ subscription }) => {
    if (!subscription) return null;
    const [openInvitationModal, setOpenInvitationModal] = React.useState(false);
    const [searchQuery, setSearchQuery] = React.useState("");
    const handleInvitationOpen = () => setOpenInvitationModal(!openInvitationModal);

    const planMembersApi = useApi(() => request(`/api/payments/${subscription.id}/members`));
    const handleSearchInput = (event) => {
        if (event.target.value === "") {
            setSearchQuery(null);
        } else {
            setSearchQuery(event.target.value);
        }
    };

    return (
        <>
            <Stack
                direction="row"
                spacing={2}
                justifyContent="space-between"
                style={{ width: "100%" }}
            >
                <Title>Step 2 - Invite your collaborators</Title>
                <Stack direction="row" spacing={1}>
                    <TextField
                        onChange={handleSearchInput}
                        type="search"
                        id="search-teams"
                        size="small"
                        label={
                            <Typography sx={{ fontSize: 12, paddingTop: "3px" }}>
                                Search users
                            </Typography>
                        }
                        variant="outlined"
                    />
                    <LoadingButton
                        color="success"
                        variant="contained"
                        onClick={handleInvitationOpen}
                    >
                        Invite users
                    </LoadingButton>
                </Stack>
            </Stack>
            <Subtitle>
                Invite additional people to your plan to make them available for adding to teams and
                give them access to team features.
            </Subtitle>
            {planMembersApi &&
                planMembersApi.status === "SUCCESS" &&
                planMembersApi.data.members &&
                planMembersApi.data.members.length === 0 &&
                planMembersApi.data.pendingMembers &&
                planMembersApi.data.pendingMembers.length === 0 && (
                    <Stack alignItems="center" pt={3} style={{ width: "100%" }}>
                        <AnnouncementIcon />
                        <Subtitle>No associated emails found.</Subtitle>
                        <Subtitle style={{ marginTop: 0 }}>
                            Feel free to invite users to plan.
                        </Subtitle>
                    </Stack>
                )}
            <Grid
                container
                direction="row"
                justifyContent="space-around"
                alignItems="flex-start"
                pt={1}
            >
                <Grid item md={6} sm={12}>
                    <Stack
                        direction="column"
                        style={{
                            paddingLeft: "24px",
                            paddingRight: "24px",
                            paddingTop: "16px",
                        }}
                    >
                        <EnterprisePlanList
                            subscription={subscription}
                            planMembersApi={planMembersApi}
                            searchQuery={searchQuery}
                        />
                    </Stack>
                </Grid>
                <Grid item md={6} sm={12}>
                    <Stack
                        direction="column"
                        style={{
                            paddingLeft: "24px",
                            paddingRight: "24px",
                            paddingTop: "16px",
                        }}
                    >
                        <EnterpriseInvitesList
                            subscription={subscription}
                            planMembersApi={planMembersApi}
                            searchQuery={searchQuery}
                        />
                    </Stack>
                </Grid>
            </Grid>

            <InvitationModal
                open={openInvitationModal}
                handleClose={setOpenInvitationModal}
                planMembersApi={planMembersApi}
                subscription={subscription}
            />
        </>
    );
};
export default EnterpriseInviteSection;
